module.exports = window.prettyPrint || (() => {});
